import { styled } from 'linaria/react';

export const FormStyled = styled.form`
  display: flex;
  flex-direction: column;
  gap: var(--space-350);
  width: 60%;

  @media (--only-mobile) {
    gap: var(--space-400);
    width: 100%;
  }
`;

export const Container = styled.div<{ noXPadding: boolean; noPaddingTop: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: ${props => (props.noPaddingTop ? '0' : 'var(--space-300)')};
  padding-right: ${props => (props.noXPadding ? '0' : 'var(--space-400)')};
  padding-bottom: var(--space-200);
  padding-left: ${props => (props.noXPadding ? '0' : 'var(--space-400)')};

  @media (--only-mobile) {
    padding: var(--space-200);
    padding-bottom: 0;
  }
`;

export const StyledHeading = styled.div`
  position: relative;
  margin-bottom: var(--space-200);

  @media (--only-mobile) {
    margin-bottom: var(--space-100);
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  gap: 11%;
  margin-top: var(--space-400);

  @media (--only-tablet) {
    gap: var(--space-500);
    margin-top: var(--space-300);
  }

  @media (--to-tablet) {
    flex-direction: column;
    gap: var(--space-400);
    min-height: 580px;
  }
`;

export const FooterContainer = styled.div`
  background-color: var(--background-primary);

  @media (--to-tablet) {
    margin-top: auto;
  }
  @media (--only-mobile) {
    position: sticky;
    bottom: 0;
    z-index: 2;
    padding: var(--space-200) 0;
  }
`;

export const FooterWrapper = styled.div`
  position: relative;
  margin-top: var(--space-500);

  @media (--only-mobile) {
    width: 100%;
    margin-top: 0;
  }
`;

export const MeasurementBannerWrapper = styled.div`
  @media (--only-mobile) {
    margin-bottom: var(--space-1000);
  }
`;
